import { duration } from '@play-co/components';
import type { State } from '../State';
import {
  initialDayStats,
  type DayStats,
  type PersistentStats,
} from './stats.ruleset';

/**
 * Get lifetime stats of user activity
 */
export function getPersistent(
  state: State,
  id: PersistentStats,
  initial: number,
): number {
  return state.stats[id] ?? initial;
}

/**
 * Get day stats of user activity
 */
export function getDayStats(state: State, id: DayStats, now: number): number {
  const dayStats = state.dayStats[id];

  // If no stats exist for the given ID, return the initial value
  if (!dayStats) {
    return initialDayStats[id].initial;
  }

  // Get the configuration for the given ID
  const config = initialDayStats[id];
  const day = duration({ day: 1 });

  // Calculate the start of the current day with offset
  const dayStart = Math.floor((now + config.timeOffsetMs) / day) * day;

  // Calculate the start of the saved day with offset
  const statsDay =
    Math.floor((dayStats.updatedAt + config.timeOffsetMs) / day) * day;

  // If the current day does not match the saved day, return the initial value
  if (statsDay !== dayStart) {
    return config.initial;
  }

  // Otherwise, return the saved counter value
  return dayStats.counter;
}
